import {useIntl} from 'react-intl';
import {useMediaQuery, useTheme} from '@mui/material';

export const useWidth = () => {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return (
    keys.reduce((output, key) => {
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || 'xs'
  );
};

export const getBreakPointsValue = (valueSet, breakpoint) => {
  if (typeof valueSet === 'number') return valueSet;
  switch (breakpoint) {
    case 'xs':
      return valueSet.xs;
    case 'sm':
      return valueSet.sm || valueSet.xs;
    case 'md':
      return valueSet.md || valueSet.sm || valueSet.xs;
    case 'lg':
      return valueSet.lg || valueSet.md || valueSet.sm || valueSet.xs;
    default:
      return (
        valueSet.xl || valueSet.lg || valueSet.md || valueSet.sm || valueSet.xs
      );
  }
};

export const getFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  let k = 1024,
    dm = 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const multiPropsFilter = (products, filters, stringKey = 'title') => {
  const filterKeys = Object.keys(filters);
  return products.filter((product) => {
    return filterKeys.every((key) => {
      if (!filters[key].length) return true;
      // Loops again if product[key] is an array (for material attribute).
      if (Array.isArray(product[key])) {
        return product[key].some((keyEle) => filters[key].includes(keyEle));
      }
      console.log('key', key, filters[key], product[key]);
      if (key === stringKey) {
        return product[key].toLowerCase().includes(filters[key].toLowerCase());
      }
      return filters[key].includes(product[key]);
    });
  });
};

// 'intl' service singleton reference
let intl;

export function IntlGlobalProvider({children}) {
  intl = useIntl();
  // Keep the 'intl' service reference
  return children;
}

export const appIntl = () => {
  return intl;
};

export const insertFilesToTree = (node, folderId, newFiles) => {
  if (!node) return node;

  if (node.id === folderId) {
    return {
      ...node,
      files_detail: [...(node.files_detail || []), ...newFiles],
    };
  }

  if (node.children?.length) {
    return {
      ...node,
      children: node.children.map((child) =>
        insertFilesToTree(child, folderId, newFiles),
      ),
    };
  }

  return node;
};

export const insertFolderToTree = (node, parentId, newFolders) => {
  if (!node) return node;

  if (node.id === parentId) {
    return {
      ...node,
      children: [...(node.children || []), ...newFolders],
    };
  }

  if (node.children?.length) {
    return {
      ...node,
      children: node.children.map((child) =>
        insertFolderToTree(child, parentId, newFolders),
      ),
    };
  }

  return node;
};

export const removeNodeById = (node, deleteId) => {
  if (!node) return node;

  const nextNode = {...node};

  if (Array.isArray(nextNode.children)) {
    nextNode.children = nextNode.children
      .filter((child) => String(child.id) !== String(deleteId))
      .map((child) => removeNodeById(child, deleteId));
  }

  return nextNode;
};

export const removeFileById = (node, deleteId) => {
  if (!node) return node;

  const nextNode = {...node};

  if (Array.isArray(nextNode.files_detail)) {
    nextNode.files_detail = nextNode.files_detail.filter(
      (file) => String(file.id) !== String(deleteId),
    );
  }

  if (Array.isArray(nextNode.children)) {
    nextNode.children = nextNode.children.map((child) =>
      removeFileById(child, deleteId),
    );
  }

  return nextNode;
};

export const replaceNodeById = (nodes, id, newNode) => {
  return nodes.map((node) => {
    if (node.id === id) {
      return {
        ...node,
        ...newNode,
      };
    }

    if (node.children?.length) {
      return {
        ...node,
        children: replaceNodeById(node.children, id, newNode),
      };
    }

    return node;
  });
};
